import Twitter from '../src/Twitter';
export default Twitter;
